import { useCallback } from 'react';
import { useState }    from 'react';

/*
useObjectState

This hook is a middle-ground between useState and useReducer. It manages a state
object and provides an updateState method to modify any part of the state,
leaving existing state properties intact.
*/

export default function useObjectState(initialState = {}) {
  const [ state, setState ] = useState(initialState);
  const updateState         = useCallback(props => {
    if (typeof props === 'function')
      setState(prevState => props(prevState));
    else
      setState(prevState => ({ ...prevState, ...props }));
  }, []);
  return [ state, updateState ];
}
